export default {
  titulo: 'Grupo Tigre',
  orders: 'Pedidos',
  order: 'Pedido',
  orderSummary: 'Resumen del pedido',
  filters: 'Filtros',
  filter: 'Filtro',
  period: 'Fecha de Creación',
  product: 'Producto',
  status: 'Status',
  newOrder: 'Nuevo Pedido',
  createdDate: 'Fecha de Creación',
  requestDate: 'Fecha de Envio',
  customer: 'Cliente',
  purchaseOrder: 'Orden de Compra',
  totalValue: 'Total',
  price: 'Valor',
  number: 'Numero',
  pendingAmount: 'Cantidad Pendiente',
  pendingFacturada: 'Cantidad Facturada',
  pendingCancelada: 'Cantidad Cancelada',
  pendingItems: 'Items Pendientes',
  tracking: 'Rastreo',
  billing: 'Facturación',
  billingDate: 'Fecha de Facturación',
  vencimientoDate: 'Fecha de Vencimiento ',
  parcial: 'Parcial',
  pendiente: 'Pendiente',
  exceeded: 'Excedido',
  itemCode: 'Articulo',
  description: 'Descrición',
  value: 'Precio',
  packingAmount: 'Cantidad Embalaje',
  discount: 'Descuento',
  weight: 'Peso Kg',
  listItems: 'Items',
  print: 'Imprimir',
  shippingLocation: 'Dirección de envío',
  deliveryDate: 'Fecha de entrega',
  noDataAvailable: 'No hay datos disponibles',
  class: 'Classe',
  itemsPerPage: 'Artículo por página',
  initialDate: 'Fecha inicial',
  finalDate: 'Fecha final',
  invalidDate: 'Fecha invalida',
  series: 'Familia',
  pdfBilling: 'Factura PDF',
  billingNumber: 'Numero de Factura',
  orderNumber: 'Numero de Pedido',
  requestedAmount: 'Cantidad Solicitada',
  productCode: 'Codigo de Producto',
  amount: 'Cantidad',
  pendingValue: 'Valor Pendiente',
  line: 'Familia',
  productLine: 'Linea',
  configColumns: 'Configurar Columnas',
  paymentTerm: 'Condición de Pago',
  orderedDate: 'Fecha del Pedido',
  carrier: 'Transportador',
  shipCity: 'Ciudad',
  fiscalCode: 'Identificación Cliente',
  canceled: 'CANCELADO',
  booked: 'REGISTRADO',
  closed: 'CERRADO',
  orderPending: 'PENDIENTE',
  readyToShip: 'PENDIENTE',
  sent: 'ENVIADO',
  selected: 'SELECIONADO',
  inPreparation: 'Preparación',
  inStepsWithConfirmedSelection: 'DESPACHO',
  awaitingReturn: 'EN ESPERA DE DEVOLUCIÓN',
  orderItems: 'Productos',
  billingItems: 'Productos',
  salesPerson: 'Asesor de Ventas',
  dateMustBeEqualOrGreaterThanInitial: 'Fecha debe ser mayor que la inicial',
  home: 'Inicio',
  eletronicBill: 'Facturas Electronicas',
  hello: '¡Hola {user}!',
  orderType: 'Tipo de pedido',
  contactName: 'Nombre del contato',
  phone: 'Teléfono',
  email: 'Email',
  deliveryLocation: 'Dirección de Entrega',
  seller: 'Vendedor',
  total: 'Total',
  valueWithoutTaxes: 'Valor sin impuestos',
  catalog: 'Catalogos',
  centroAyuda: 'Centro de ayuda',
  creditLimit: 'Limite de crédito',
  available: 'Disponible',
  expirado: 'Expirado',
  consumed: 'Consumido',
  porVencer: 'Por Vencer',
  vencido: 'Vencido',
  Total: 'Pagado',
  quotes: 'Cotações',
  Pendiente: 'Pendiente de Pago',
  Parcial: 'Pago parcial',
  Expirado: 'Expirado',
  desconto: 'Descuento',
  descontoMaximo: 'Descuento Máximo',
  pesquisar: "Buscar...",
  carregando: "Cargando...",
  numero: "Número",
  organizacao: "Organización",
  documento: "Documento",
  ordemCompra: "Orden de compra",
  dataCriacao: "Fecha de creación",
  condicaoPagamento: "Condiciones de pago.",
  codigo: "Código",
  produto: "Producto",
  produtos: "Productos",
  quantidade: "Cantidad",
  nAbreviado: "No.",
  itens: "Artículos",
  item: "Articulo",
  todos: "Todas",
  cancelado: "Cancelado",
  emAnalise: "En análisis",
  pendente: "Pendiente",
  emSeparacao: "Separando",
  faturado: "Facturado",
  emTransporte: "En carro",
  entregue: "Entregado",
  pedido: "Orden",
  pedidos: "Peticiones",
  financeiro: "Financiero",
  pagamentos: "Pagos realizados",
  limiteCredito: "Limite de crédito",
  devolucao: "Devolución",
  numeroNf: "Fact. no.",
  parcela: "Parte",
  duplicata: "Parte",
  cnpj: "COZINHOU",
  cpf: "COZINHOU",
  dataEmissao: "Fecha de emisión",
  dataVencimento: "Fecha de venc.",
  dataPagamento: "Fecha de pago.",
  valorJuros: "Interesar",
  outrosServicos: "Otros servicios",
  acoes: "Comportamiento",
  consumido: "Consumado",
  disponivel: "Disponible",
  avencer: "Ganar",
  pago: "Pagado",
  em: "en",
  textWhatsapp: "Hola, soy :NOME, estaba navegando en e-Tigre y necesito ayuda.",
  ajudaWhatsapp: "Ayuda via Whatsapp",
  deixeSuaOpiniao: "Deja tu opinion",
  bancoImagens: "Banco de imagenes",
  ultimos12Meses: "Últimos 12 meses",
  consultaAtualizaEm: "Consulta actualizada el",
  ambienteHomologacao: "Entorno de homologación",
  cidade: "Ciudad",
  data: "Fecha",
  numPedido: "Núm. de orden",
  cliente: "Cliente",
  repVendas: "Rep. de ventas",
  pedidosPendentes: "Ordenes Pendientes",
  tempoEstimadoEnvio: "Tiempo estimado de envío",
  horas: "Horas",
  centroDistribuicao: "Centro de Distribución",
  precoUnit: "Precio unit.",
  precoUnitDiscounted: "Precio unit. neto",
  precoUnitTotalDiscounted: 'Total',
  pedidosEmEspera: "Órdenes en espera",
  totalOrdem: "Orden Total",
  enderecoEnvio: "Dirección de Envío",
  filtro: "Filtrar",
  devolucoesCreditos: "Devoluciones y Créditos",
  numeroPeca: "Número de pieza",
  codigoTigre: "Código Tigre",
  instrucoesEnvio: "Instrucciones de Envío",
  tipoFrete: "Tipo de Carga",
  statusPedido: "Estado de la orden",
  tipoPedido: "Tipo de orden",
  filtreQualquerCampoPressioneEnter: "Filtre por cualquier campo y presione la tecla \"Enter\" para enviar",
  faturamento: "Ingresos",
  faturamentos: "Facturación",
  dataPedido: "Fecha de Solicitud",
  dataFaturamento: "Fecha de Facturación",
  fatura: "Factura",
  valorFrete: "Costo del Flete",
  novaCotacao: "Nueva Cotización",
  cotacoes: "Citas",
  companhia: "Empresa",
  enviarPara: "Enviar Para",
  telefone: "Teléfono",
  fax: "Fax",
  observacoes: "Notas",
  digiteTresCaracteresParaPesquisar: "Ingrese al menos 3 caracteres para buscar",
  naoHaItensDisponiveis: "No hay artículos disponibles",
  contratoFrete: "Acuerdo de Transporte de Mercancías",
  listaPreco: "Lista de Precios",
  types: 'Tipos',
  qtdCaixa: "Cant. de Caja",
  salvar: "Salvar",
  fechar: "Cerca",
  editarItem: "Editar Artículo",
  multiplo: "Múltiple",
  salvarItem: "Salvar Artículo",
  sair: "Cerrar Sesión",
  nenhumItemSelecionadoItemSendoCalculado: "No se ha seleccionado ningún artículo o se está calculando el artículo",
  companhiaObrigatorio: "Empresa requerida",
  enderecoEnvioObrigatorio: "Se requiere enviar a la dirección",
  ordemCompraObrigatorio: "Se requiere pedido de comprador del cliente",
  registroInseridoSucesso: "Registro insertado correctamente",
  erroTentarInserirRegistro: "Error al intentar insertar el registro",
  dataDesejada: "Fecha Deseada",
  qtdPalete: "Cant. Palet",
  domesticOrders: "Domestic Orders: Minimum price US$ 500.00",
  internationalOrders: "International Orders: The order has to be full box quantity",
  valorMinimoPedido: "Cantidad Mínima de Pedido",
  requisitosCriacaoPedido: "Requisitos para Crear el Pedido",
  precos: "Precios",
  textoPrecos: "Los precios están sujetos a cambios en cualquier momento sin previo aviso. Todos los pedidos están sujetos a aprobación crediticia antes del envío.",
  valorMinimoPedido500: "El valor mínimo del pedido es de $500.00.",
  valorMinimoPedido250: "El valor mínimo del pedido es de $250.00",
  textoCondicaoPagto: "2% 30 días, 45 días netos. Las condiciones de pago son para clientes existentes al día. Los términos de pago para clientes nuevos y OEM se determinan en el momento de realizar el pedido.",
  frete: "Flete",
  freteDentroEUAContinental: "Dentro de los Estados Unidos Continentales",
  textoFreteDentroEUAContinental: "Los pedidos de tubos y / o accesorios enviados dentro de los EE. UU. Continentales son de fábrica FOB, flete prepago y reembolsado.",
  freteForaEUAContinental: "Fuera de los Estados Unidos Continentales",
  textoFreteForaEUAContinental: "Los pedidos de tubos y / o accesorios enviados fuera de los EE. UU. Continentales son en la planta FOB (el puerto), con flete prepagado al puerto y con cargo. INCOTERM es Ex Works.",
  freteCompletoPermitido: "Envío Completo Permitido",
  textoFreteCompleto: "Pedidos de accesorios de PVC: pedido neto mínimo de $1,500.00 enviado desde una ubicación y entregado en una ubicación",
  devolucoesReabastecimento: "Devoluciones y repostaje",
  textoDevolucoesReabastecimento: "Se requiere una autorización de devolución de material (RMA) para todas las devoluciones. Antes de devolver cualquier artículo, comuníquese con Servicio al Cliente para obtener más detalles al 608-754-4554 o customerservice@tigre.com. Todos los artículos devueltos tendrán una tarifa de reposición del 25% al ​​devolver e inspeccionar el producto. Los artículos deben estar en \"condición de venta\" para calificar para la autorización de crédito",
  cancelamento: "Cancelación",
  textoCancelamento: "Los productos no estándar o personalizados no se pueden cancelar una vez iniciada la producción. Grandes cantidades de un solo producto pueden requerir un contrato no cancelable",
  garantiaProduto: "La Garantía del Producto",
  garantiaLimitada: "GARANTÍA LIMITADA",
  textoGarantiaLimitada: "El vendedor garantiza únicamente que los productos aquí cubiertos serán fabricados según las especificaciones acordadas y libres de defectos de material y mano de obra bajo un uso y servicio adecuado y normal por un período de un año a partir de la fecha de envío. Las muestras de productos suministradas o mostradas por el Vendedor no pretenden ser representativas de los productos vendidos y los productos vendidos pueden diferir materialmente de dichas muestras. El Comprador notificará al Vendedor sobre cualquier supuesto defecto dentro de las 48 horas posteriores al descubrimiento del supuesto defecto y dentro de un año. El vendedor no es responsable de ningún reclamo de garantía si no se proporciona dicho aviso. El Vendedor puede, a su discreción, y sujeto a su derecho a inspeccionar los productos supuestos defectuosos y su aceptación de cualquier reclamo de garantía, aceptar permitir que el Comprador realice trabajos de reparación en el sitio o en otro lugar, siempre que el Vendedor esté de acuerdo de antemano con el costo de la reparación. escrito. Las reparaciones, reemplazos u otros remedios sin una inspección previa por parte del Vendedor o sin autorización por escrito del Vendedor anularán esta garantía. Esta garantía limitada es nula si los productos vendidos no se instalan de acuerdo con las mejores prácticas o no son instalados por un contratista autorizado con licencia calificado para instalar los productos o si los productos no se utilizan de acuerdo con las instrucciones contenidas en cualquier manual de servicio. o si las mercancías se utilizan en condiciones distintas de aquellas para las que fueron diseñadas. Los productos no se pueden devolver sin la autorización previa por escrito del vendedor.",
  textoGarantiaLimitadaNegrito: "ESTA GARANTÍA REEMPLAZA TODAS LAS DEMÁS GARANTÍAS ESTATUTARIAS, EXPRESAS O IMPLÍCITAS, INCLUIDAS LAS GARANTÍAS DE COMERCIABILIDAD Y APTITUD PARA UN PROPÓSITO EN PARTICULAR, QUE SE RECHAZAN POR LA PRESENTE",
  textoLimitacaoResponsabilidade: "LIMITACIÓN O RESPONSABILIDAD: EL VENDEDOR NO SERÁ RESPONSABLE BAJO NINGUNA CIRCUNSTANCIA POR DAÑOS INCIDENTALES, CONSECUENTES O ESPECIALES, INCLUYENDO: (1) DAÑOS DERIVADOS DEL PROYECTO, FABRICACIÓN, FABRICACIÓN, VENTA, USO, INSTALACIÓN, VENTA , USO, INSTALACIÓN, USO, PROVISIÓN, USO, PROVISIÓN, VENTA, USO, PROVISIÓN, VENTA, USO, PROVISIÓN, VENTA, USO, PROVISIÓN, VENTA, USO, PROVISIÓN, VENTA, USO, ORAL DE; (2) DAÑOS DE PRODUCTOS QUE FUERON INCORPORADOS EN OTRO PRODUCTO; (3) DAÑOS DERIVADOS DE CUALQUIER INCUMPLIMIENTO DEL CONTRATO; O (4) DAÑOS QUE SURJAN DE CUALQUIER OTRA CAUSA, YA SEA BASADO EN EL CONTRATO, DELITO O CUALQUIER OTRA TEORÍA DE RESPONSABILIDAD, E INDEPENDIENTEMENTE DE CUALQUIER CONSEJO O DECLARACIONES QUE PUEDA HABER PROPORCIONADO POR EL VENDEDOR EN RELACIÓN CON EL DISEÑO, USO, INSTALACIÓN O SUMINISTRO DE PRODUCTOS. LA OBLIGACIÓN DEL VENDEDOR BAJO LA GARANTÍA LIMITADA ANTERIOR ES ESTRICTA Y EXCLUSIVAMENTE LIMITADA A LA REPARACIÓN O REEMPLAZO GRATUITO DE DICHOS PRODUCTOS QUE SEAN DEFECTUOSOS EN EL MATERIAL O EN LA FORMA PROPORCIONADA Y LIMITADA ANTERIORMENTE.",
  textoLimitacaoResponsabilidadeNegrito: "EL VENDEDOR SE RESERVA EL DERECHO DE SATISFACER TOTALMENTE SU OBLIGACIÓN DE GARANTÍA, CON RESPECTO A LOS PRODUCTOS DEFECTUOSOS, PARA EL PAGO AL COMPRADOR DE TODOS LOS PRODUCTOS PAGADOS POR EL COMPRADOR AL VENDEDOR POR DICHOS PRODUCTOS",
  atencao: "ADVERTENCIA",
  textoObservacao: "La prueba de presión de aire de las conexiones de presión de PVC instaladas está estrictamente prohibida por razones de seguridad en caso de falla. Las conexiones de PVC producidas por Tigre USA Inc. no están diseñadas para el transporte o almacenamiento de aire comprimido o gases. Si estos productos se utilizan en este tipo de aplicaciones, la garantía se anulará automáticamente",
  voltar: "Vuelve",
  adicionarNovoEndereco: "Agregar Nueva Dirección",
  endereco: "Dirección",
  estado: "Expresar",
  enderecoPostal: "Código Postal",
  salvarEndereco: "Salvar Dirección",
  cotacao: "Precio",
  transportadora: "Transportadora",
  informacoesRastreamento: "Información de Seguimiento",
  naoHaDadosDisponiveis: "Datos no disponibles",
  produtosLinhaDevemPedidosQuantidadesCompletas: "Los productos :LINHA deben pedirse en cajas completas. Múltiple: :VALOR",
  caixaCom: "Caja de",
  pesquisandoProdutosPorFavorAguarde: "Buscando productos. Espere por favor...",
  ou: "o",
  naoImportado: "No Importado",
  importado: "Importado",
  erroImportacao: "Error de Importación",
  reprovado: "Desaprobado",
  logImportacao: "Importar Registro",
  dataImportacao: "Fecha de Importación",
  numPedImportado: "Número de Orden Importado",
  importando: "Importador",
  campoObrigatorio: "Campo obligatorio",
  arquivosTotalMaior: "Total de archivos de más de {size}MB",
  limiteMaximoArquivos: "Límite máximo de {count} archivos: {size}MB",
  maximoArquivos: "Máximo de {count} archivos",
  enviar: "Enviar",
  anexarBalancoesDRE: "Adjunte los balances de los últimos 2 años con DRE.",
  aumentarLimiteCredito: "Aumentar el límite de crédito",
  extensaoSuportada: "Extensión admitida: {ext}",
  erroLeituraArquivos: "Hubo un error al leer los archivos.",
  problemaSolicitacao: "Hubo un problema al enviar la solicitud. Vuelve a intentarlo más tarde.",
  recebemosSolicitacao: "Recibimos su solicitud para aumentar su límite de crédito. Estamos analizando y tu comercial te posicionará.",
  arquivo: "Archivo",
  dias: "Días",
  atendentes: "Acomodadores",
  nome: "Nombre",
  cargo: "Oficina",
  setorAtividade: "Sector de actividad",
  OrganizacaoSetorAtividade: "Organización y sector de actividad",
  atendimento: "Asistencia",
  imagem: "Imagen",
  semImagem: "Sin Imagen",
  sessaoExpirada: "Su sesión ha caducado.",
  salvarRascunho: "Guardar Borrador",
  enviarPedido: "Enviar Orden",
  limparFiltro: "Filtro Limpio",
  buscar: "Búsqueda",
  buscarProdutos: "Búsqueda de Productos",
  sale_channel: "Canal de Venta/Segmento",
  category: "Categoria",
  taxes: 'Impuestos',
  subtotal: 'Total parcial',
  consultationUpdatedOn: 'Consulta actualizada el',
  trocarCliente: 'Cambiar Cliente',
  dataFaturamentoInicial: 'Fecha de Facturación Inicial',
  dataFaturamentoFinal: 'Fecha de Facturación Final',
  busca: 'Busca'
};
